import { ACTION_AUTH, ACTION_CLEAR_AUTH, SET_ACCOUNT_TYPE } from '../constants/actions';

export function Auth(state = {} as AuthReducer.IState, action = {} as AuthReducer.IAction) {
  switch (action.type) {
    case ACTION_AUTH: {
      return { ...state, ...action.payload };
    }
    case SET_ACCOUNT_TYPE: {
      return { ...state, ...action.payload };
    }
    case ACTION_CLEAR_AUTH: {
      return {} as AuthReducer.IState;
    }
    default:
      return state;
  }
}
